import { TSpeakerContent } from "../../../services/api/instances/meetingsApi/types";
import { SPEAKER_UNDEFINED } from "../constants";

export const getActiveSpeaker = (
  speakers: TSpeakerContent[]
): TSpeakerContent[] => {
  const hasActiveSpeaker = speakers.some((speaker) => speaker.isActive);

  return hasActiveSpeaker
    ? speakers.filter(
        (speaker) =>
          speaker.isActive || speaker.speaker_group_key === SPEAKER_UNDEFINED
      )
    : speakers;
};
